import {inject, observer} from "mobx-react";
import * as React from "react";
import Base, {IBaseProps} from "./base";

@inject('rootStore')
@observer
export default class Error404 extends Base<IBaseProps> {
    public render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        document.title = `${this.rootStore.sysInfo.name} | ${this.translate("error.heading", "Error")} 404`;

        return <div className="container container-component">
            <h3>{this.translate("error.not-found", "Oops! We did not find what you were looking for")}!</h3>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/error-404.tsx